export default __webpack_public_path__ + "static/media/expl-dissect_13_EN.e4a1f8bb.png";